import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import {Stack} from '@mui/material';
import {getSearchForm} from '@shared/services/service-handlers/PrivateService';
import {getErrorMessage} from '@shared/utils/ErrorUtils';
import {useSnackbar} from 'notistack';
import {useEffect, useState} from 'react';
import TabsComponent from '../../sub-modules-menu/tabsComponent/TabsComponent';
import {useAppContext} from '@context/AppContext';
import {LoadingScreen} from 'src/minimal-components/loading-screen';

interface GLReportsComponentProps {
  module: string;
  menu_item: string;
}

const GLReportsComponent = (props: GLReportsComponentProps): JSX.Element => {
  const {
    appState: {applicationName}
  } = useAppContext();

  const {enqueueSnackbar} = useSnackbar();
  const [tabData, setTabData] = useState({});
  const [loader, setLoader] = useState(false);
  const init = async () => {
    try {
      if (props.module) {
        setLoader(true);
        const res = await getSearchForm(
          applicationName,
          props.module,
          props.menu_item
        );
        setTabData(res.searchForm);
        setLoader(false);
      }
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
      setLoader(false);
    }
  };
  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      {!loader && tabData && Object.keys(tabData).length ? (
        <TabsComponent
          sectionUIData={tabData}
          sectionRowsData={[]}
          module={props?.module}
        />
      ) : (
        <Stack
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          minHeight={'80vh'}>
          <LoadingScreen />
        </Stack>
      )}
    </div>
  );
};

export default GLReportsComponent;
